import { mascaraTelefone } from '@entregas/core';
import type { ComponentProps } from 'react';
import { Campo } from './Campo';

/**
 * Telefone com DDD: formata "(27) 99999-9999" enquanto digita (colar "+55 27 9…" também vale).
 * Serve controlado (value + onChange) e solto (defaultValue + FormData): a máscara é aplicada no
 * próprio input antes do onChange de quem usa.
 */
export function CampoTelefone({
  onChange,
  defaultValue,
  ...resto
}: Omit<ComponentProps<typeof Campo>, 'type' | 'inputMode'>) {
  return (
    <Campo
      type="tel"
      inputMode="tel"
      autoComplete="tel-national"
      placeholder="(27) 99999-9999"
      defaultValue={typeof defaultValue === 'string' ? mascaraTelefone(defaultValue) : defaultValue}
      onChange={(e) => {
        e.currentTarget.value = mascaraTelefone(e.currentTarget.value);
        onChange?.(e);
      }}
      {...resto}
    />
  );
}
